import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

// utitls
import { validations } from "utils/validations";

import { dropdown } from "utils/dropdown";

import { logout } from "utils/common";

// primereact components
import { Card } from "primereact/card";

import { Button } from "primereact/button";

// images
import logo from "assets/images/logo.png";

import config from "assets/config";
import { connect } from "react-redux";

const Register = () => {
  let history = useHistory();

  const [registerFormFields, setRegisterFormFields] = useState({
    name: {
      properties: {
        type: "InputText",
        label: "Name",
        fieldWrapperClassNames: "p-md-6",
        primeFieldProps: {},
        validations: {
          required: validations.required,
        },
      },
    },

    email_address: {
      properties: {
        type: "InputText",
        label: "Email",
        fieldWrapperClassNames: "p-md-6",
        primeFieldProps: {
          keyfilter: "email",
          readOnly: true,
        },
        validations: {
          required: validations.required,
          pattern: validations.email,
        },
      },
    },

    abhyasi_id: {
      properties: {
        type: "InputText",
        label: "Abhyasi ID",
        fieldWrapperClassNames: "p-md-6",
        validations: {
          pattern: validations.abhyasiId,
        },
      },
    },

    contact_number: {
      properties: {
        type: "PhoneInput",
        label: "Contact Number",
        fieldWrapperClassNames: "p-md-6",
        primeFieldProps: {},
        validations: {
          required: validations.required,
        },
      },
    },
    country: {
      properties: {
        type: "DropdownCountry",
        label: "Country",
        fieldName: "country_id",
        fieldWrapperClassNames: "p-md-6",
        primeFieldProps: {},
        validations: {
          required: validations.required,
        },
        dropdownOptions: "country",
      },
    },
    state: {
      properties: {
        type: "StateAutoCom",
        label: "State",
        fieldName: "state",
        fieldWrapperClassNames: "p-md-6",
        primeFieldProps: {},
        validations: {
          required: validations.required,
        },
      },
    },
    city: {
      properties: {
        type: "CityAutoCompleteRegister",
        label: "City",
        fieldWrapperClassNames: "p-md-6",
        searchField: "name",
        fieldLabel: "name",
        validations: {
          required: validations.required,
          minLength: {
            value: 3,
            message: "Search value must be minimum 3 character...",
          },
        },
      },
    },
    pincode: {
      properties: {
        type: "InputText",
        label: "Pincode",
        fieldWrapperClassNames: "p-md-6",
        primeFieldProps: {},
        validations: {
          required: validations.required,
          maxLength: {
            value: 10,
            message: "Please enter pincode with maximum 10 characters",
          },
        },
      },
    },
    address: {
      properties: {
        type: "InputTextarea",
        label: "Address",
        fieldWrapperClassNames: "p-col-12",
        primeFieldProps: {},
      },
    },
    photo: {
      properties: {
        type: "ProfileUpload",
        label: "Photo",
        fieldWrapperClassNames: "p-md-6",
        hint: `Maximum allowed file size is ${config.profileImageMaxFIleSize}MB. Allowed types are jpg, jpeg and png`,
        primeFieldProps: {
          accept: ".jpg,.jpeg,.png",
          onChange: (file) => {
            if (file.target.files.length !== 0) {
              setRegisterFormFields({
                ...registerFormFields,
                imageCrop: {
                  ...registerFormFields.imageCrop,
                  properties: {
                    ...registerFormFields.imageCrop.properties,
                    visibility: true,
                  },
                },
                previewImage: {
                  ...registerFormFields.previewImage,
                  properties: {
                    ...registerFormFields.previewImage.properties,
                    visibility: true,
                  },
                },
              });
            } else {
              setRegisterFormFields({
                ...registerFormFields,
                imageCrop: {
                  ...registerFormFields.imageCrop,
                  properties: {
                    ...registerFormFields.imageCrop.properties,
                    visibility: false,
                  },
                },
                previewImage: {
                  ...registerFormFields.previewImage,
                  properties: {
                    ...registerFormFields.previewImage.properties,
                    visibility: false,
                  },
                },
              });
            }
          },
        },
      },
    },

    imageCrop: {
      properties: {
        type: "imageCrop",
        label: "Selected Image",
        visibility: false,
        fieldWrapperClassNames: "p-md-6",
        primeFieldProps: {
          accept: ".jpg, .jpeg, .png",
        },
      },
    },
    previewImage: {
      properties: {
        type: "previewImage",
        label: "Preview Image",
        visibility: false,
        fieldWrapperClassNames: "p-md-6",
        primeFieldProps: {
          accept: ".jpg, .jpeg, .png",
        },
      },
    },
  });


  const LogOutSignup = async () => {
    await logout(false);
    localStorage.setItem("logt", "yes");
    history.push("/login");
  };

  useEffect(async () => {
    dropdown.zone();
    dropdown.country();
    dropdown.userRoleList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="login-section register-section">
      <div className="card-wrapper">
        <div className="loging-logo p-mb-4 p-text-center">
          <img src={logo} alt="heartfulness" />
        </div>

        <Card>
          <div className="register">
            <div className="d-flex flex-column align-items-center">
              <p>You don&apos;t have the necessary permissions. Please contact administrator.</p>
              <div className="proceed-btn">
                <Button
                  label="Login with another Account"
                  className="primary-btn mx-4"
                  onClick={LogOutSignup}
                />
              </div>
              <small className="mt-3">
                <b>
                  Note: On clicking &quot;Login with another account&quot; you
                  will be logged out from all Heartfulness applications in this
                  browser.
                </b>
              </small>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  ld: state.loginDetails,
});

export default connect(mapStateToProps)(Register);
